/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { mq, googleTagManagerEvent, useBooleanState } from '../../../../helpers'
// import Button from './Button'
import { gsColors } from '../../../../styles/Variables'
import Color from 'color'
import lightBulbSvg from '../../../../../public/images/lightbulb.svg'
import checkmarkSvg from '../../../../../public/images/checkmark.svg'
import Modal from './Modal'
import UpArrow from '../../../nav/UpArrow'
import DownArrow from '../../../nav/DownArrow'
import Button from '../../../Button'
import CheckboxSingle from './CheckboxSingle'
import { orderBy } from 'lodash'
import { Header3, Text } from '../../../../styles/Components'

const SelectMarketServiceDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: center;
  position: relative;
  overflow: hidden;

  .container {
    overflow: auto;

    .details {
      width: 50%;
      padding: 30px;
      box-sizing: border-box;

      &.full-width {
        width: 100%;
      }

      ${mq('max', '768px')} {
        width: 100%;
        padding: 30px 20px;
      }
      
      .price-and-time {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .service-price {
          ${mq('max', '768px')} {
            font-size: 16px !important;
          }
        }
      }
      
      .service-description {
        text-align: left;
        
        ${mq('max', '768px')} {
          font-size: 14px !important;
        }
      }
      

      .clients {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: ${props => (props.addOns ? '20px' : 'auto')};
    
        .how-many {
          ${mq('max', '768px')} {
            font-size: 14px !important;
          }
        }
    
        .client-counter {
          display: flex;

          filter: none;

          ${mq('max', '768px')} {
            filter: none !important;
          }
  
    
          button {
            cursor: pointer;
            background-color: ${gsColors.white};
            background-position: center;
            background-repeat: no-repeat;
            border: 0;
            outline: 0;
            width: 40px;
            height: 40px;
            position: relative;
    
            &.subtract {
              border: solid ${gsColors.lightTangerine};
              border-width: 1px 0 1px 1px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            
            &.add {
              border: solid ${gsColors.lightTangerine};
              border-width: 1px 1px 1px 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            &:disabled {
              &::after {
                content: "";
                position: absolute;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                background-color: rgba(255, 255, 255, 0.5);
              }
            }
          }
    
          .client-count {
            border: 1px solid ${gsColors.lightTangerine};
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;

            p {
              ${mq('max', '768px')} {
                font-size: 16px !important;
              }
            }
          }
        }
      }

      .bp-options {
        display: flex;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 35px;
        gap: 9px;
    
        > div {
          box-sizing: border-box;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-evenly;
          padding: 12px 0 12px 20px;
          width: 50%;
          height: 96px;
          border: 1px solid ${gsColors.lightTangerine};

          ${mq('max', '768px')} {
            p {
              font-size: 14px !important;
            }
          }
    
          &.active {
            border: 1.5px solid ${gsColors.sunsetOrange};
            
            .description {
              p {
                color: ${gsColors.sunsetOrange};
              }
            }
          }
        }
    
        .bp-count {
          color: ${gsColors.saltBox};
        }
      }

      .service-duration {
        display: flex;
        align-items: center;

        p {
          ${mq('max', '768px')} {
            font-size: 14px !important;
          }
        }

        img {
          margin-right: 5px;
        }
      }
      
      .details-dropdown {
        display: flex;
        flex: 1;
        flex-direction: column;
        max-height: 60px;
        height: max-content;
        overflow: hidden;
        box-sizing: border-box;

        .details-button {
          border: none;
          padding: 0;
          background-color: white;
          width: 100%;
          margin-top: 35px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
        }

        .dropdown-content {
          max-height: 250px;
          overflow: auto;

          &.informational {
            margin: 24px 0 0;
          }
        }

        &.open {
          max-height: 10000px;
        }

        p {
          text-align: left;

          ${mq('max', '768px')} {
            font-size: 12px;
          }
        }
      }
    }

    ${mq('min', '768px')} {
      display: flex;
      height: 100%;
      overflow: hidden;
    }
  }

  .service-name {
    text-transform: capitalize;

    ${mq('max', '768px')} {
      font-size: 28px !important;
    }
  }

  .service-pro-tip {
    background: ${gsColors.provincialPink} url(${lightBulbSvg}) no-repeat 12px
      center;
    border-radius: 10px;
    margin: 0 15px 20px;
    padding: 12px 12px 12px 50px;

    ${mq('min', '768px')} {
      margin: 0 0 20px;
    }

    p {
      font-size: 12px;
      line-height: 1.66;
      text-align: left;
    }
  }

  .add-ons {
    padding: 67px 38px;
    width: 55%;
    background-color: ${gsColors.khaki};
    overflow: auto;

    ${mq('max', '768px')} {
      width: 100%;
      padding: 27px 20px;
      padding-bottom: 50px;
      box-shadow: inset 0px 5px 10px 0px rgba(0,0,0,0.2);
    }

    .add-on-title {
      text-align: left;

      ${mq('max', '768px')} {
        font-size: 13px !important;
      }
    }


    .upgrade {
      font-size: 18px;
      letter-spacing: -0.43px;
      line-height: 1;
    }

    .headline {
      color: ${gsColors.honeyFlower};
      font-size: 12px;
      font-weight: bold;
      line-height: 20px;
      letter-spacing: 0.86px;
      margin: 0;
      padding-top: 20px;
      text-transform: uppercase;

      ${mq('min', '768px')} {
        margin-bottom: 40px;
        padding-top: 16px;
      }
    }

    .add-on {
      // padding: 15px 20px;
      // position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 10px;
      padding: 18px 0;
      border-bottom: 1px solid ${gsColors.lightTangerine};


      .top, .bottom {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;

        ${mq('max', '768px')} {
          h3 {
            font-size: 16px !important;
          }
          p {
            font-size: 14px !important;

            &.price {
              font-size: 16px !important;
            }
          }
        }
      }

      .bottom {
        p {
          max-width: 80%;
          text-align: left;
        }
      }

    }

    .add-on-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      ${mq('min', '768px')} {
        margin-bottom: 5px;
      }

      .gs-checkbox-circle {
        label {
          padding: 0;
        }
      }
    }

    .add-on-name {
      font-size: 14px;
      line-height: 20px;
      margin: 0 auto 0 0;

      ${mq('min', '768px')} {
        font-size: 16px;
      }
    }

    .add-on-price {
      font-weight: bold;
      line-height: 20px;
      margin-right: 24px;

      ${mq('min', '768px')} {
        margin-right: 10px;
      }
    }

    .add-on-description {
      color: ${gsColors.saltBox};
      font-size: 12px;
      line-height: 1.5;
      max-width: 244px;
      text-align: left;

      ${mq('min', '768px')} {
        max-width: 190px;
      }
    }
  }

  .gs-checkbox-circle {
    input:checked + label {
      .box {
        background-color: ${gsColors.honeyFlower};
        background-image: url(${checkmarkSvg});
        box-shadow: none;
      }
    }

    input[type='checkbox'] {
      display: none;
    }

    .box {
      background: ${gsColors.hintOfRed} no-repeat center;
      // box-shadow: inset 0 0 2px 0 ${Color(gsColors.black).alpha(0.2).string()};
      border: none;
      border-radius: 50%;
      display: block;
      position: relative;
      transition: all 250ms;
      width: 24px;
      height: 24px;
    }
  }

  .service-footer {
    background-color: ${gsColors.white};
    display: block;
    bottom: 0;
    width: 100%;
    flex-shrink: 0;
  }
`

/**
 * SelectMarketServiceModal
 *
 * @param {*} {
  marketService: PropTypes.object,
  select: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
 * }
 * @returns
 */
const SelectMarketServiceModal = ({
  marketService,
  select,
  isOpen,
  close,
  isDesktop
}) => {

  const [selectedAddOnMarketServicesById, setSelectedAddOnMarketServicesById] =
    useState({})

  // number of clients to receive this service
  const [instances, setInstances] = useState(1)

  // back to back
  const [backToBack, setBackToBack] = useState(true)
  const [detailsOpen, toggleDetailsOpen] = useBooleanState(false)

  useEffect(() => {
    if (marketService) {
      googleTagManagerEvent('viewServiceDetail', {
        serviceViewedName: marketService.service.name,
        serviceTypeViewedName: marketService.service.serviceType.name
      })
    }
  }, [marketService])

  if (!marketService) {
    return null
  }

  // reset options when closed
  if (!isOpen) {
    if (Object.keys(selectedAddOnMarketServicesById).length) {
      setSelectedAddOnMarketServicesById({})
    }
    if (instances !== 1) {
      setInstances(1)
    }
    if (!backToBack) {
      setBackToBack(true)
    }
  }

  /**
   * isAddOnMarketServiceSelected: checks if this add-on is selected
   *
   * @param {*} addOnMarketService
   * @returns
   */
  const isAddOnMarketServiceSelected = addOnMarketService => {
    return !!selectedAddOnMarketServicesById[addOnMarketService.id]
  }

  /**
   * addOnSelectedChanged: changes selection state of add-on
   *
   * @param {*} addOnMarketService
   * @param {*} selected
   */
  const addOnSelectedChanged = (addOnMarketService, selected) => {
    if (isAddOnMarketServiceSelected(addOnMarketService) === selected) {
      return
    }

    if (selected) {
      selectedAddOnMarketServicesById[addOnMarketService.id] =
        addOnMarketService
    } else {
      delete selectedAddOnMarketServicesById[addOnMarketService.id]
    }

    setSelectedAddOnMarketServicesById({ ...selectedAddOnMarketServicesById })
  }

  const selectServicesAndClose = () => {
    // add service to bag or, if informational, open url in new window
    if (!marketService.service?.isInformational) {
      // add to cart
      select({
        marketService,
        addOnMarketServices: Object.values(selectedAddOnMarketServicesById),
        instances,
        backToBack
      })
    } else {
      const newWindow = window.open(
        marketService.service?.informationalUrl,
        '_blank',
        'noopener,noreferrer'
      )
      if (newWindow) {
        newWindow.opener = null
      }
    }

    return close()
  }

  const {
    price,
    duration,
    service: {
      name: serviceName,
      id: serviceId,
      description: serviceDescription,
      isInformational,
      maxPerAppointment,
      infoHowToPrep,
      infoWhatsIncluded
    },
    addOnMarketServices
  } = marketService

  return (
    <Modal
      isOpen={isOpen}
      bottom={isInformational ? undefined : '60px'}
      closeModal={close}
      fullHeight={isInformational ? false : true}
      padding="0"
      width={isInformational ? '400px' : '836px'}
      isDesktop={isDesktop}
    >
      <SelectMarketServiceDiv
        addOns={addOnMarketServices.length ? true : false}
      >
        <section className="container">
          <div className={`details ${(!addOnMarketServices.length || isInformational) ? 'full-width' : ''}`}>
            {/* <h5 className="service-name">{serviceName.toLowerCase()}</h5> */}
            <Header3 
              fontSize={28} 
              lineHeight='140%'
              className='service-name'
              margin='0 0 8px'
            >
              {serviceName.toLowerCase()}
            </Header3>
            <div className='price-and-time'>
              <div className='service-duration'>
                {!!duration && (<>
                  <img src='/images/booking-time-icon.svg' alt='duration' />
                  <Text
                    color={gsColors.meredithGrey}
                    lineHeight='145%'
                    spacing={0.16}
                  >
                    {duration} mins
                  </Text>
                </>)}                
              </div>
              <Text 
                variant='medium'
                lineHeight='140%'
                className="service-price"
              >
                {/* price is 0 for event services */}
                {price !== 0 && '$' + price}
              </Text>
            </div>
            <Text 
              className='service-description'
              color={gsColors.meredithGrey}
              lineHeight='145%'
              spacing={0.16}
              margin='24px 0'
            >
              {serviceDescription}
            </Text>
            {maxPerAppointment > 1 && (
              <div className="clients">
                <Text
                  lineHeight='140%'
                  className='how-many'
                >
                  How many clients?
                </Text>
                <div className="client-counter">
                  <button
                    disabled={instances === 1}
                    onClick={() => setInstances(instances - 1)}
                    className="subtract"
                  >
                    <img src='/images/booking-minus-icon.svg' alt='remove' />
                  </button>
                  <div className="client-count">
                    <Text weight={500}>{instances}</Text>
                  </div>
                  <button
                    disabled={instances === maxPerAppointment}
                    onClick={() => setInstances(instances + 1)}
                    className="add"
                  >
                    <img src='/images/booking-plus-icon.svg' alt='add' />
                  </button>
                </div>
              </div>
            )}
            {instances > 1 && (
              <div className="bp-options">
                <div
                  className={backToBack ? 'active' : ''}
                  onClick={() => setBackToBack(true)}
                >
                  <div className="description">
                    <Text
                      weight={600}
                      lineHeight='140%'
                      fontSize={14}
                    >
                      Back to Back
                    </Text>
                  </div>
                  <div className='service-duration'>
                    <img src='/images/booking-time-icon-black.svg' alt='duration' />
                    <Text
                      lineHeight='140%'
                      fontSize={14}
                    >
                      {duration * instances} min
                    </Text>
                  </div>
                  <Text
                    lineHeight='140%'
                    color={gsColors.meredithGrey}
                    fontSize={14}
                    
                  >
                    1 beauty pro
                  </Text>
                </div>
                <div
                  className={!backToBack ? 'active' : ''}
                  onClick={() => setBackToBack(false)}
                >
                  <div className="description">
                    <Text
                      weight={600}
                      lineHeight='140%'
                      fontSize={14}
                    >
                      At the same time
                    </Text>
                  </div>

                  <div className='service-duration'>
                    <img src='/images/booking-time-icon-black.svg' alt='duration' />
                    <Text
                      lineHeight='140%'
                      fontSize={14}
                    >
                      {duration} min
                    </Text>
                  </div>
                  <Text
                    className="bp-count"
                    lineHeight='140%'
                    fontSize={14}
                  >
                    {instances} beauty pros
                  </Text>
                </div>
              </div>
            )}
            {isDesktop && (
              <Button
                large
                onClick={selectServicesAndClose}
                fill
                hover
              >
                {isInformational ? 'Contact Us' : 'Add Service'}
              </Button>
            )}
            {(infoHowToPrep || infoWhatsIncluded) && (
              <div className={`details-dropdown ${(detailsOpen || isInformational) ? 'open' : ''}`}>
                {!isInformational && (
                  <button 
                    className='details-button'
                    onClick={toggleDetailsOpen}
                  >
                    <Text
                      lineHeight='140%'
                    >
                      Details
                    </Text>
                    {detailsOpen ? <UpArrow /> : <DownArrow />}
                  </button>
                )}
                <div className={`dropdown-content ${isInformational ? 'informational' : ''}`}>
                  {infoWhatsIncluded && (
                    <>
                      <Text
                        margin='12px 0 0'
                        fontSize={14}
                        weight={600}
                        lineHeight='20px'
                        align='left'
                      > 
                        What to expect:
                      </Text>
                      <Text
                        fontSize={14}
                        lineHeight='20px'
                        color={gsColors.meredithGrey}
                      >
                        {infoWhatsIncluded}
                      </Text>
                    </>
                  )}
                  {infoHowToPrep && (
                    <>
                      <Text
                        margin='12px 0 0' 
                        fontSize={14}
                        weight={600}
                        lineHeight='20px'
                      > 
                        How to prepare:
                      </Text>
                      <Text
                        fontSize={14}
                        lineHeight='20px'
                        color={gsColors.meredithGrey}

                      >
                        {infoHowToPrep}
                      </Text>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          {addOnMarketServices.length > 0 && !isInformational && (
            <div className="add-ons">
              <Text
                fontSize={13}
                spacing={0.52}
                className='add-on-title'
              >
                POPULAR ADD-ONS
              </Text>
              {orderBy(addOnMarketServices, 'service.priority', 'asc').map(addOnMarketService => {
                const {
                  addOnPrice,
                  service: {
                    addOnName,
                    addOnDescription,
                    id: addOnMarketServiceId
                  }
                } = addOnMarketService

                const checkboxName = [serviceId, addOnMarketServiceId].join()
                const isChecked =
                  isAddOnMarketServiceSelected(addOnMarketService)

                return (
                  <div key={addOnMarketService.id} className="add-on">
                    <div className='top'>
                      <Header3 lineHeight='140%'>
                        {addOnName}
                      </Header3>
                      <Text fontSize={20} lineHeight='145%' spacing={0.2} className='price'>
                        ${addOnPrice}
                      </Text>
                    </div>
                    <div className='bottom'>
                      <Text
                        lineHeight='22px'
                        spacing={0.16}
                        color={gsColors.meredithGrey}
                      >
                        {addOnDescription}
                      </Text>
                      <CheckboxSingle
                        whiteUnchecked
                        textComponent={() => null}
                        name={checkboxName}
                        value={isChecked}
                        onChange={() => addOnSelectedChanged(addOnMarketService, !isChecked)}
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </section>
        {!isDesktop && (
          <footer className="service-footer">
            <Button 
              onClick={selectServicesAndClose}
              large
              fill
              hover
            >
              {isInformational ? 'Contact Us' : 'Add Service'}
            </Button>
          </footer>
        )}
      </SelectMarketServiceDiv>
    </Modal>
  )
}

SelectMarketServiceModal.propTypes = {
  marketService: PropTypes.object,
  select: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool
}

export default SelectMarketServiceModal
